import { RequestContextHeader as Header } from '@coolblue-development/next-request-context-utils';
import { getRequestContext } from './getRequestContext.js';
import { getOverrides } from './overrides/getOverrides.js';
export const getServerRequestContext = async () => {
    const context = await getRequestContext();
    const original = mapServerRequestContext(context);
    if (!original.isInternalUser) {
        return original;
    }
    const overrides = await getRequestContextWithOverrides(context);
    // If the internal user wants to behave like external traffic (?overridehost), we ignore all other overrides.
    if (!overrides.isInternalUser) {
        return { ...original, isInternalUser: false };
    }
    return overrides;
};
export const getOriginalRequestContext = async () => {
    return mapServerRequestContext(await getRequestContext());
};
const getRequestContextWithOverrides = async (original) => {
    const overrides = await getOverrides();
    return mapServerRequestContext({ ...original, ...overrides });
};
const mapServerRequestContext = (context) => {
    return {
        accountId: context[Header.COOLBLUE_ACCOUNT_ID],
        accountName: context[Header.COOLBLUE_ACCOUNT_NAME],
        attemptId: context[Header.ATTEMPT_ID],
        authToken: context[Header.COOLBLUE_AUTH_TOKEN],
        clientIp: context[Header.CLIENT_IP],
        cookiePreferences: context[Header.COOKIE_PREFERENCES],
        correlationId: context[Header.CORRELATION_ID],
        customerId: context[Header.COOLBLUE_CUSTOMER_ID],
        csrfToken: context[Header.CSRF_TOKEN],
        device: context[Header.DEVICE],
        environment: context[Header.ENVIRONMENT],
        coolblueApp: context[Header.COOLBLUE_APP] || undefined,
        isCoolblueApp: context[Header.COOLBLUE_APP] !== '',
        isInternalUser: context[Header.IS_COOLBLUE_USER] === 'true',
        isKnownBot: context[Header.IS_COOLBLUE_KNOWN_BOT] === 'true',
        isLoggedIn: context[Header.COOLBLUE_ACCOUNT_ID] !== '' && context[Header.COOLBLUE_AUTH_TOKEN] !== '',
        isNewSession: context[Header.IS_NEW_SESSION] === 'true',
        isRecognizedUser: context[Header.COOLBLUE_ACCOUNT_ID] !== '' && context[Header.COOLBLUE_AUTH_TOKEN] === '',
        language: context[Header.LANGUAGE],
        requestId: context[Header.CLOUDFRONT_REQUEST_ID],
        route: context[Header.ROUTE],
        sessionId: context[Header.COOLBLUE_SESSION_ID],
        splitTests: context[Header.SPLIT_TESTS],
        subsidiary: context[Header.SUBSIDIARY],
        trafficSource: context[Header.TRAFFIC_SOURCE],
        trackingId: context[Header.COOLBLUE_TRACKING_ID],
    };
};
//# sourceMappingURL=getServerRequestContext.js.map